import { Component, OnInit, OnChanges, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'pager',
  templateUrl: './pager.component.html',
  styleUrls: ['./pager.component.css']
})
export class PagerComponent implements OnChanges {

  public showingNav;
  public showingTo;
  public total_items_count;
  public page_actual;
  public total_pages;
  public pages;
  public items_per_page = "10";

  public paginar = {
    page: 1,
    perpage: '10',
    search: '',
    esbusqueda: false,
    sortby: '',
    sort: '' //ASC - DESC
  };

  @Input() paginado;
  @Output() changePage: EventEmitter<number>;
  @Output() changePerPage: EventEmitter<number>;

  constructor() {
    this.changePage = new EventEmitter;
    this.changePerPage = new EventEmitter;
  }

  ngOnChanges() {
    console.log(this.paginado);

    this.items_per_page = String(this.paginado.items_per_page);
      this.paginar.perpage = String(this.paginado.items_per_page);
      this.paginar.sort = this.paginado.order;
      this.paginar.sortby = this.paginado.orderby;
      this.page_actual = this.paginado.page_actual;
      this.total_items_count = this.paginado.total_items_count;
      this.total_pages = this.paginado.total_pages;

      this.showingTo = this.paginado.page_actual * this.paginado.items_per_page;
      this.showingNav = (this.paginado.page_actual * this.paginado.items_per_page) - (this.paginado.items_per_page - 1);
      
      let valorfor = this.page_actual - 2;
      if  (valorfor < 0) { valorfor = 0; }
      this.pages = [];
      let cont = 0;
      for (let i = valorfor; i < this.paginado.total_pages; i++) {
        let vaalortest = this.page_actual - i;
        // console.log(vaalortest);
        this.pages.push(i);
        cont++;
        if (cont > 5) { break; }
      }
  }

  goToPage(page) {
    this.changePage.emit(page);
  }

  changeLimit() {
    this.changePerPage.emit(Number(this.items_per_page));
  }

}
